import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GoogleLogin } from "react-google-login";
import { loginApi } from "../../../api";
import { setToken } from "../../../redux";
import { Alert } from "../../../shared";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LoginFlat.css";
import { ThemeLanguageToggle } from "./ThemeLanguageToggle";

const LoginComp = (props) => {
  const { t } = useTranslation();
  const [showHome, setShowHome] = useState(false);
  
  useEffect(() => {
    if (Cookies.get("token")) {
      setShowHome(false);
      props.history.push("/panel");
    } else {
      setShowHome(true);
    }
  }, []);

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  
  const dispatch = useDispatch();
  const clientId =
    "329703603574-m25trgmnld1lobprk0rphnvimcdf5070.apps.googleusercontent.com";
  const form = useRef(null);

  const initialLoginValues = {
    email: "",
    password: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    loginApi(data)
      .then((res) => {
        dispatch(setToken(res.data.data.token));
        Cookies.set("token", res.data.data.token);
        props.history.push("/panel");
      })
      .catch(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          question: false,
          message: t("نام کاربری و یا رمز عبور شما اشتباه است"),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);
      });
  };

  const validationSchemaLogin = Yup.object({
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
    password: Yup.string().required(t("رمز عبور را وارد کنید.")),
  });

  const onSuccess = (res) => {
    // console.log("yeeeeeees" + res);
  };

  const onFailure = (res) => {
    // console.log("nooooo" + res);
  };

  const goToForgotPassword = () => {
    props.history.push("/forgotpassword");
  };

  return (
    <>
      {showHome && (
        <div className="login-flat-container">
          {/* Theme and Language Controls */}
          <ThemeLanguageToggle />
          
          <div className="login-flat-card">
            {/* Header Section */}
            <div className="login-flat-header">
              <div className="login-flat-icon-wrapper">
                <svg className="login-flat-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6ZM12 20C9.97 20 7.57 19.18 5.86 17.12C7.55 15.8 9.68 15 12 15C14.32 15 16.45 15.8 18.14 17.12C16.43 19.18 14.03 20 12 20Z" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="login-flat-title">{t("ورود")}</h2>
              <p className="login-flat-subtitle">{t("دسترسی به حساب")}</p>
            </div>
            
            {/* Form Section */}
            <div className="login-flat-form">
              <Formik
                initialValues={initialLoginValues}
                onSubmit={submitLoginForm}
                validationSchema={validationSchemaLogin}
              >
                {(props) => (
                  <Form ref={form}>
                    {/* Email Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                          type="email"
                          placeholder={t("ایمیل")}
                          name="email"
                          className="login-flat-input"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    {/* Password Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                          type="password"
                          name="password"
                          placeholder={t("رمز عبور")}
                          className="login-flat-input"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      <ErrorMessage name="password">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    <a className="login-flat-forgot" onClick={goToForgotPassword}>
                      {t("رمز عبور خود را فراموش کردید؟")}
                    </a>
                    
                    <button
                      type="submit"
                      className="login-flat-button"
                    >
                      {t("ورود")}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
            
            {/* Divider */}
            <div className="login-flat-divider">
              <span>{t("یا")}</span>
            </div>
            
            {/* Google Login */}
            <div className="login-flat-google">
              <GoogleLogin
                clientId={clientId}
                onSuccess={onSuccess}
                onFailure={onFailure}
                style={{ width: "100%" }}
                isSignedIn={true}
              />
            </div>
            
            {/* Register Link */}
            <div className="login-flat-register">
              <a onClick={() => props.history.push("/register")}>
                {t("حساب کاربری ندارید؟ ثبت نام کنید!")}
              </a>
            </div>
          </div>
          
          {showAlert.show && (
            <Alert message={showAlert.message} type={showAlert.type} />
          )}
        </div>
      )}
    </>
  );
};

const Login = withRouter(LoginComp);

export { Login };
